/**
 * Fixed strings and style maps for the provider surface.
 *
 * Separated from the components so a copy change is not a diff against auth
 * logic, and so the tables can be read without scrolling past a state machine.
 *
 * @module
 */
import { ThreadId } from "@cmmd-forge/contracts";

export const CODEX_DEVICE_AUTH_HELP_URL = "https://chatgpt.com/#settings/Security";

export const CODEX_AUTH_BROWSER_THREAD_ID = ThreadId.make("settings-codex-auth");

export const PROVIDER_STATUS_STYLES = {
  disabled: {
    dot: "bg-muted-foreground/40",
  },
  error: {
    dot: "bg-destructive",
  },
  offline: {
    dot: "bg-muted-foreground/40",
  },
  ready: {
    dot: "bg-success",
  },
  warning: {
    dot: "bg-warning",
  },
} as const;

export const PROVIDER_RUNTIME_LABELS = {
  local: "Local",
  master: "Master",
  "user-vm": "User VM",
} as const;

export const PROVIDER_CREDENTIAL_SCOPE_LABELS = {
  proxied: "Forge-managed proxy credential",
  shared: "Shared Forge credential",
  user: "User credential",
} as const;

export const PROVIDER_CREDENTIAL_SOURCE_LABELS = {
  environment: "Environment",
  "forge-managed": "Forge managed",
  "process-default": "Process default",
  "server-settings": "Server settings",
} as const;

/**
 * Forge debug disclosure flag.
 *
 * Authentication provenance — credential scope, runtime role, account
 * label, binary path, etc. — leaks the operator's identity and is not
 * meant for client-facing builds. Setting `localStorage["forge:debug-mode"]`
 * to `"true"` in DevTools opts the current browser into seeing the full
 * provenance disclosure (headline suffix + expanded "Authentication
 * provenance" panel). Off by default everywhere.
 */
